import React from 'react'
import '../scss/section/sectionmain.scss';
import Frame from '../Component/images/Frame.png';


export default function SectionMain() {
  return (
    <div className='sectionmain'>
      <div className='main_text'>Inspiration for the next adventure</div>
     
        <div className='main_component'>

          <div className='card_container'>
              <div>
                <img className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>
          <div className='card_container'>
              <div>
                <img className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>
          <div className='card_container'>
              <div >
                <img className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>
           <div className='card_container'>
              <div className=''>
                <img  className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>


          <div className='card_container'>
              <div>
                <img className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>
          <div className='card_container'>
              <div>
                <img className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>
          <div className='card_container'>
              <div >
                <img className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>
           <div className='card_container'>
              <div className='image_container'>
                <img  className='image' src={Frame} alt="nft homes"/>
                {/* <div>Love</div> */}
              </div>
              <div className='text_one'>
                  <div className='name_nft'>Desert King</div>
                  <div className='price_nft'>IMBT per night</div>
              </div>
              <div className='text_one'>
                  <div className='distance_nft'>2345km away</div>
                  <div className='duration_nft'>available for 2weeks stay</div>
              </div>
              <div className='rating'>
                  star
              </div>
              
          </div>

        </div>
       




      </div>
  )
}
